import React from "react";
import { default as MuiTextField } from "@mui/material/TextField";
import { DefaultFormProps } from "./form.types";
import { Skeleton } from "@mui/material";

interface TextFieldProps extends DefaultFormProps {
    textBox?: boolean;
    value?: string;
    isLoading?: boolean;
    styles?: object;
    placeholder?: string;
    readonly?: boolean;
}

const defaultProps: Partial<TextFieldProps> = {
    required: false,
    fullWidth: true,
    autoFocus: false,
    error: false,
    disabled: false,
    textBox: false,
    value: "",
    isLoading: false,
    styles: {},
    readonly: false,
};

const TextField = React.forwardRef(function TextField(props: TextFieldProps) {
    props = { ...defaultProps, ...props };

    return (
        <MuiTextField
            size="small"
            margin="normal"
            required={props.required}
            fullWidth={props.fullWidth}
            name={props.name}
            label={props.label}
            value={props.isLoading ? "" : props.value}
            type={"text"}
            onChange={props.onChange}
            autoFocus={props.autoFocus}
            error={props.error}
            disabled={props.disabled}
            helperText={props.errorMessage}
            multiline={props.textBox}
            rows={props.textBox ? 3 : 0}
            InputProps={{
                readOnly:props.readonly,
                startAdornment: props.isLoading ? (
                    <Skeleton width={"200%"} />
                ) : null,
            }}
            // InputLabelProps={{
            //     shrink: true,
            // }}
            style={props.styles}
            placeholder={props.placeholder}
        />
    );
});

export default TextField;
